import P from '@leverege/promise';
import LayerCreatorFactory from "./layerCreators/canvas/LayerCreatorFactory.js";
import { addLayersToCollection } from "./Util.js";
export default async function getKonvaLayers(opts) {
  const {
    layers: pLayers,
    context
  } = opts;
  const layerDescriptors = [];
  await P.mapLimit(pLayers, async layerModel => {
    let layer = LayerCreatorFactory.create({
      ...layerModel,
      useReact: false
    }, null, {
      ...context
    });
    if (layer.then) {
      layer = await layer;
    }
    addLayersToCollection(layer, layerDescriptors);
    return layer;
  });
  const layers = layerDescriptors.map(l => l.layer);
  return {
    layers
  };
}